import { ReactNode } from "react";
import * as React from "react";
import { observer } from "mobx-react";

import SwipeProductOne from "./GridOne";
import SwipProductTwo from "./GridTwo";
import ProductTags from "../NormalProducts/ProductTags";
import Loading from "../../components/Loading";

import { ProductsWrap, ProductCardWrap } from "./styles";
import ProductStore from "./store";
import { isNotBlankArray } from "utils/array";
import { TProductElement, TProductBaseProps } from "../../../services/product";
import { TTagModule, ModuleLayoutStyle } from "../../../services/playground";
import { isInWindowView, returnProductIndex } from "utils/browser";

export type WebSlideProductsProps = TProductBaseProps & {
	width: number;
	posterRatio?: number;
};
export interface WebSlideProductsState {
	activeTab: string;
	isChangeTab: boolean;
	showedProducts: TProductElement[];
}
@observer
class WebSlideProducts extends React.Component<WebSlideProductsProps, WebSlideProductsState> {
	private contentRef: React.RefObject<HTMLDivElement> = React.createRef();
	private productsCardRef: React.RefObject<HTMLDivElement> = React.createRef();

	productStore: ProductStore;
	hasListener: boolean = false;
	scrollEndTimer: NodeJS.Timeout;
	scrollTop: number = 0;
	preProductIndex: number = 0;

	static defaultProps = {
		stickToTop: 0,
	};

	constructor(props: WebSlideProductsProps) {
		super(props);

		this.productStore = new ProductStore(props.productModules);
		const activeTab = props.activeTab || props.productModules[0]?.poolId;
		this.state = {
			activeTab,
			isChangeTab: false,
			showedProducts: (this.productStore.productsListMap[activeTab] || []).slice(
				0,
				this.getMaxByCard(),
			),
		};
	}

	componentDidMount() {
		const { loadProductsList, productsListMap } = this.productStore;
		const currentPool = productsListMap[this.state.activeTab];
		if (!isNotBlankArray(currentPool)) {
			loadProductsList(this.state.activeTab, this.props.onLoadPool);
		}
		window.addEventListener("scroll", this.onScroll);
		/** 初始化页面需要 */
		this.preProductIndex === 0 && this.trackOnShow(true, true);
	}
	componentWillUnmount() {
		window.removeEventListener("scroll", this.onScroll);
	}
	onScroll = () => {
		clearTimeout(this.scrollEndTimer);
		this.scrollEndTimer = setTimeout(this.isScrollEnd, 600);
		this.scrollTop = window.scrollY || window.pageYOffset;
	};
	isScrollEnd = () => {
		const endTop = window.scrollY || window.pageYOffset;
		const placeHolderCurrent = this.contentRef.current as HTMLElement;
		if (endTop === this.scrollTop && isInWindowView(placeHolderCurrent)) {
			this.trackOnShow(true);
		}
	};
	trackOnShow = (isScroll: boolean = false, isInit: boolean = false) => {
		const productsCardRefCurrent = this.productsCardRef.current as HTMLElement;
		const isInwindow = isInWindowView(productsCardRefCurrent);
		const { SetCtrTrackOnShow, SetGtmTrackOnShow } = this.props;
		const { showedProducts, activeTab } = this.state;
		const { exposureProductListMap, productsListMap } = this.productStore;
		const exposureProducts = exposureProductListMap[activeTab] || null;
		// const preProductIndex = preIndex || this.preProductIndex;
		const productList = productsListMap[activeTab];
		if (isNotBlankArray(showedProducts) && (SetCtrTrackOnShow || SetGtmTrackOnShow)) {
			const posArr: number[] = [];
			const pidsArr: string[] = [];
			let exportArr: string[] = [];
			showedProducts.forEach((item) => {
				let exposureItem = null;
				const productIndex = returnProductIndex(item.gpid, productList);
				if (exposureProducts) {
					exposureItem = exposureProducts.find((it) => it === item.gpid);
					exportArr = exposureProducts;
				}
				const productNode = document.getElementById(`${activeTab}${item.gpid}`);
				if (
					isInwindow &&
					productNode &&
					isInWindowView(productNode) &&
					!exposureItem &&
					productIndex
				) {
					// posArr.push(i + 1 + this.preProductIndex);
					posArr.push(productIndex);
					pidsArr.push(item.gpid);
					exportArr.push(item.gpid);
				}
			});
			if (posArr.length > 0) {
				SetCtrTrackOnShow && SetCtrTrackOnShow(posArr.join(","), pidsArr);
				SetGtmTrackOnShow && SetGtmTrackOnShow(showedProducts, posArr);
				this.trackOnShowUpdate(isScroll, isInit, exportArr);
			}
		}
	};

	// trackOnShow更新数据，存储数据
	trackOnShowUpdate = (isScroll: boolean, isInit: boolean, exposureProducts: string[]) => {
		const { handleExposureProductList } = this.productStore;
		const { showedProducts, activeTab } = this.state;
		if (isScroll || isInit) {
			this.preProductIndex = showedProducts.length;
		}
		// 计算是否要清空数组, 当只是滚动的时候,还是原来的数组
		if (isScroll) {
			this.setState({
				showedProducts,
			});
		} else {
			this.setState({ showedProducts: [] });
		}
		handleExposureProductList(activeTab, exposureProducts);
	};

	getMaxByCard = () => {
		const { layout } = this.props;
		let { columnNum = 4, rowNum = 1 } = layout;
		columnNum = Math.max(1, columnNum);
		rowNum = Math.max(1, rowNum);
		return columnNum * rowNum;
	};

	onTagsChange = async (category: TTagModule, index: number, fixed: boolean) => {
		if (this.props.onClickTab) {
			this.props.onClickTab(index);
		}
		const { loadProductsList, productsListMap } = this.productStore;
		let hasTrackOnshow = false;
		if (isNotBlankArray(productsListMap[category.id])) {
			hasTrackOnshow = true;
		}
		this.setState({
			activeTab: category.id,
			showedProducts: [],
			isChangeTab: true,
		});
		this.preProductIndex = 0;
		const nextProducts = (await loadProductsList(category.id, this.props.onLoadPool)) || [];
		productsListMap[category.id];
		this.setState(
			{
				showedProducts: [...this.state.showedProducts, ...nextProducts].slice(
					0,
					this.getMaxByCard(),
				),
				isChangeTab: false,
			},
			() => {
				this.trackOnShow();
			},
		);
		!hasTrackOnshow && this.trackOnShow();
		/* scroll to top */
		if (fixed) {
			const offsetTop = this.contentRef?.current?.offsetTop || 0;
			const { stickToTop = 0 } = this.props;
			window.scrollTo(0, offsetTop - stickToTop);
		}
	};
	onClickProduct = (pos: string, pid: string) => {
		this.props.SetCtrTrackOnAction && this.props.SetCtrTrackOnAction(pos, pid);
	};

	onClickBack = () => {
		const { activeTab: poolId } = this.state;
		const { productsListMap = {} } = this.productStore;
		const products: TProductElement[] = productsListMap[poolId];
		if (!isNotBlankArray(products)) {
			return;
		}
		// const preIndex = this.preProductIndex;
		// 点击返回的时候需要先减，获取到上一页要展示的数据
		this.preProductIndex = this.preProductIndex - this.state.showedProducts.length;
		if (this.preProductIndex === 0) {
			this.preProductIndex = products.length;
		}
		this.setState(
			{
				showedProducts: products.slice(
					Math.max(this.preProductIndex - this.getMaxByCard(), 0),
					this.preProductIndex,
				),
			},
			() => {
				this.trackOnShow(false, false);
			},
		);
	};

	onClickNext = () => {
		const { activeTab: poolId } = this.state;
		const { productsListMap = {} } = this.productStore;
		// 获取整个数组
		const products: TProductElement[] = productsListMap[poolId];

		if (!isNotBlankArray(products)) {
			return;
		}
		if (this.preProductIndex === products.length) {
			this.preProductIndex = 0;
		}
		const lastIndex = this.preProductIndex + this.getMaxByCard();

		// 截取数组
		let showedProducts: TProductElement[] = products.slice(
			this.preProductIndex,
			Math.min(lastIndex, products.length),
		);
		if (lastIndex > products.length) {
			showedProducts = [...showedProducts, ...products.slice(0, lastIndex - products.length)];
		}
		// const preIndex = this.preProductIndex;
		this.setState(
			{
				showedProducts,
			},
			() => {
				// 点下一步的时候需要后更新下一个preProductIndex
				this.preProductIndex = this.preProductIndex + showedProducts.length;
				this.trackOnShow(false, false);
			},
		);
	};

	renderList = (poolId: string, { gridCol }: { gridCol: number }): ReactNode => {
		const {
			layout,
			positionId,
			minWidth = 0,
			width,
			posterRatio = 1,
			layoutStyle = ModuleLayoutStyle.Orange,
			placeholderBg,
			scoreOptions,
			productDisplayInfo,
		} = this.props;
		const { productsListMap = {} } = this.productStore;
		const products: TProductElement[] = productsListMap[poolId];
		if (!products) {
			return null;
		}
		const gridGap = layout.gap || 12;
		if (layout.rowNum === 2) {
			return (
				<SwipProductTwo
					products={products}
					gridWidth={Math.max(width, minWidth)}
					posterRatio={posterRatio}
					gridCol={gridCol}
					gridGap={gridGap}
					id={positionId}
					scoreOptions={scoreOptions}
					placeholderBg={placeholderBg}
					handWheel={productDisplayInfo?.slideWheel}
					onClick={this.onClickProduct}
					onClickBack={this.onClickBack}
					onClickNext={this.onClickNext}
					layoutStyle={layoutStyle}
					poolId={poolId}
				/>
			);
		}

		return (
			<SwipeProductOne
				products={products}
				gridWidth={Math.max(width, minWidth)}
				gridCol={gridCol}
				gridGap={gridGap}
				posterRatio={posterRatio}
				id={positionId}
				scoreOptions={scoreOptions}
				handWheel={productDisplayInfo?.slideWheel}
				onClick={this.onClickProduct}
				onClickBack={this.onClickBack}
				onClickNext={this.onClickNext}
				layoutStyle={layoutStyle}
				placeholderBg={placeholderBg}
				poolId={poolId}
			/>
		);
	};
	renderBody = () => {
		const { layout } = this.props;
		const { columnNum = 4 } = layout;
		const { isChangeTab, activeTab: poolId } = this.state;
		const loading = poolId ? this.productStore.isLoadingProducts[poolId] : false;

		return (
			<>
				{isChangeTab ? (
					<Loading style={{ height: "380px" }} />
				) : (
					<ProductCardWrap ref={this.productsCardRef}>
						{this.renderList(poolId, { gridCol: columnNum })}

						{loading && <Loading />}
					</ProductCardWrap>
				)}
			</>
		);
	};

	render() {
		const { stickToTop, positionId, tagGroup = [], width = 1200 } = this.props;
		const poolId = this.state.activeTab;

		return (
			<ProductsWrap id={positionId} gridWidth={width} ref={this.contentRef}>
				{isNotBlankArray(tagGroup) && (
					<ProductTags
						stickToTop={stickToTop}
						onChange={this.onTagsChange}
						activeTab={poolId || ""}
						tagGroup={tagGroup}
					/>
				)}
				{this.renderBody()}
			</ProductsWrap>
		);
	}
}

export default WebSlideProducts;
